// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Asset revision marker; bump to force new digests (turbo-track then reloads
// clients that cached a bad copy of this bundle).
window.assetRev = "2026-08-11.1"

// Initialize Sentry for frontend error tracking (must be first)
import "./sentry"

import "@hotwired/turbo-rails"
import "@hotwired/hotwire-native-bridge"

// Recover the practice answer form from frame-missing responses (idle-tab CSRF
// 422s, transient origin 5xx) instead of dead-ending on "Content missing".
import "./turbo_frame_recovery"

// Render frames through a fragment we hold, so WebKit cannot collect the JS state
// of a nested <turbo-frame> mid-render ("this.delegate.connect" on test_practice).
import "./turbo_frame_render"

require("@rails/activestorage").start()

import "./controllers"

// Lexxy (the rich-text editor: lexical, prism, marked, dompurify — ~500 KB minified)
// is only needed on the manage wiki-page form. It stays in its own chunk (esbuild code
// splitting) and is fetched the first time a page renders a <lexxy-editor>; defining the
// custom element late upgrades the elements already in the DOM.
let lexxyPromise = null
function loadLexxyIfNeeded() {
  if (lexxyPromise || !document.querySelector("lexxy-editor")) return
  lexxyPromise = import("@37signals/lexxy")
}
for (const event of ["turbo:load", "turbo:render", "turbo:frame-load", "turbo:frame-render"]) {
  document.addEventListener(event, loadLexxyIfNeeded)
}

import Pagy from "pagy";

window.addEventListener("turbo:load", Pagy.init);
